module.exports = __webpack_public_path__ + "img/2.1c8d6e73.png";